// @ts-nocheck
import React from 'react';
import isEqual from 'lodash/isEqual';
import { incomeScheduleApi } from './../../lib/api';
import { nomenclatureType } from './../../lib/enum';
import AutocompleteSelect from './AutocompleteSelect';
const areEqual = (prevProps, nextProps) => isEqual(prevProps.filter, nextProps.filter) && prevProps.value === nextProps.value;
export default React.memo(({
  filter = {},
  ...selectProps
}) => <AutocompleteSelect fetch={async params => {
  return await incomeScheduleApi.fetchIncomeSchedule({
    ...filter,
    ...params
  });
}} refetchParams={{
  filter
}} fetchSingle={incomeScheduleApi.getIncomeSchedule} notFoundText="Графики поступлений не найдены" placeholder="Выберите график" renderOption={(incomeSchedule, Option) => <Option key={incomeSchedule.id} value={incomeSchedule.id} incomeschedule={incomeSchedule}>
          {`${nomenclatureType[incomeSchedule.nomenclatureName]} ${incomeSchedule.count} ${incomeSchedule.sum} руб.`}
        </Option>} {...selectProps} />, areEqual);
